module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"railcars":"Вагон","vehicles":"ТС","boat":"Баржа"}}')
  delete Component.options._Ctor
}
